import React from 'react'

function ChalitChakra() {
  return (
    <div>ChalitChakra</div>
  )
}

export default ChalitChakra